
import Component from '../../../assets/scripts/modules/component'

const clampNumber = (value, min, max) => Math.max(min, Math.min(max, value))

class PhotoParallaxComponent extends Component {
  init () {
    this.picture = this.element.querySelector('.picture')
    this.image = this.element.querySelector('.picture__image')
    this.offset = null

    if (!this.picture || !this.image) {
      return
    }

    window.addEventListener('scroll', () => window.requestAnimationFrame(() => this.updateParallax()))
    window.addEventListener('resize', () => window.requestAnimationFrame(() => this.updateParallax()))
    this.updateParallax()
  }

  updateParallax () {
    const rect = this.image.getBoundingClientRect()
    const centerlineOffset = rect.top + (rect.height / 2) - (window.innerHeight / 2)
    const clampLimit = (window.innerHeight / 2) + (rect.height / 2)
    const clampedOffset = clampNumber(centerlineOffset, -clampLimit, clampLimit)
    const adjustedOffset = (clampedOffset / 5) + 'px'

    if (adjustedOffset !== this.offset) {
      this.image.style.transform = `translate3d(0, calc(-12.5% + ${adjustedOffset}), 0)`
    }

    this.offset = adjustedOffset
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.photo-parallax').forEach(element => {
  element.instance = element.instance || new PhotoParallaxComponent(element)
}))
